import { useInfiniteQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getPhotoAlbumByUser(query) {
  const { pageParam, ...restQuery } = query;
  const response = await defaultFetch('/PhotoAlbum/FindByUser', {
    ...restQuery,
    firstResult: pageParam === 0 ? 0 : (pageParam * 5) + 5,
    maxResult: pageParam === 0 ? 51 : 5
  }, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function usePhotoAlbumByUser(query) {
  const oneMinute = 1000 * 60;
  return useInfiniteQuery({
    queryKey: ['photo-album-by-user', query],
    initialPageParam: 0,
    staleTime: oneMinute,
    getNextPageParam: (lastPage, allPages) => (lastPage.length ? allPages.length + 1 : undefined),
    queryFn: async ({ pageParam }) => getPhotoAlbumByUser({ pageParam, ...query })
  });
}
